import { render, staticRenderFns } from "./latest.vue?vue&type=template&id=e9b2dece&lang=pug&"
import script from "./latest.vue?vue&type=script&lang=js&"
export * from "./latest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports